import axios from "axios";

const providerManagerAssociationsUrl = "/api/v1/provider_manager_associations";

const providerManagerAssociationsApi = {
  show: id => axios.get(`${providerManagerAssociationsUrl}/${id}`),
  create: payload =>
    axios.post(`${providerManagerAssociationsUrl}`, {
      provider_manager_association: payload,
    }),
  update: (id, payload) =>
    axios.put(`${providerManagerAssociationsUrl}/${id}`, {
      provider_manager_association: payload,
    }),
  delete: id => axios.delete(`${providerManagerAssociationsUrl}/${id}`),
  fetch_associations: (sourceEntityItemID, targetEntityID) =>
    axios.get(
      `${providerManagerAssociationsUrl}/fetch_associations/${sourceEntityItemID}`,
      {
        params: { target_entity_id: targetEntityID },
      }
    ),
};

export default providerManagerAssociationsApi;
